Ext.define('SA.view.QuickReportViewToolbar', {
    extend: 'SA.view.Toolbar',

    initComponent() {
        var fill = {xtype: 'pvt-fill'},
            contentLabel = {xtype: 'pvt-text', text: 'Report Content:'},
            exportBtn = {xtype: 'pvt-export-button', margin: '0 10 0 0'},
            contentCombo = this.getContentCombo(),
            viewActionsCombo = this.getViewActionsMenuButton();

        this.items = [contentLabel, contentCombo, fill, viewActionsCombo, exportBtn];

        this.callParent();
    },

    getContentCombo() {
        var model = this.model,
            items = model.getReportContentDropDownItems(),
            needsItems = !items.length;

        return {
            xtype: 'combo-button',
            emptyText: 'Loading…',
            disabled: needsItems,
            items,
            ui: 'underline',

            listeners: {
                async beforerender(cmp) {
                    cmp.refresh();

                    cmp.mon(model, 'change:quickReportTemplate', cmp.refresh, cmp);

                    if (needsItems) {
                        await model.reportContentDropDownItemsLoaded();

                        if (!cmp.el) {
                            return;
                        }

                        cmp.setItems(model.getReportContentDropDownItems());
                        cmp.enable();
                    }
                }
            },

            refresh() {
                this.setValue(model.getQuickReportTemplateType());
            },

            selectHandler(value) {
                model.setQuickReportTemplateType(value);
                model.save();
            }
        };
    },

    getViewActionsMenuButton() {
        var customItems = [{xtype: 'menu-hide-country'}];

        return SA.view.ViewActionsMenuBuilder.build({projectView: this.model, customItems});
    }
});